// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ltoDetails":"_1IABEA","adBugWrapper":"_1JXMiP","tooltipWrapper":"_2eV3mX","detailsText":"_1oKYtC"};